import { render, staticRenderFns } from "./microorg.vue?vue&type=template&id=79313124&scoped=true&"
import script from "./microorg.vue?vue&type=script&lang=js&"
export * from "./microorg.vue?vue&type=script&lang=js&"
import style0 from "./microorg.vue?vue&type=style&index=0&id=79313124&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79313124",
  null
  
)

export default component.exports